// @flow
import React, {type Node} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'
import {withRouter} from 'react-router'
import {AppRouterContextProvider, routerContextFallback} from 'utils/AppRouter'
import FullSearch from './FullSearch'
import type {
  Search_viewer as Viewer,
} from './__generated__/Search_viewer.graphql'

type Props = $ReadOnly<{
  autofocus: boolean,
  viewer: Viewer,
}>

const FullSearchWithRouter = withRouter(FullSearch)

function Search({
  autofocus,
  viewer,
}: Props): Node {
  const renderFullSearchFallOutOfSPA = () => (
    <FullSearch
      autofocus={autofocus}
      viewer={viewer}
      {...routerContextFallback}
    />
  )

  return (
    <AppRouterContextProvider
      fallback={renderFullSearchFallOutOfSPA}
    >
      <FullSearchWithRouter
        autofocus={autofocus}
        viewer={viewer}
      />
    </AppRouterContextProvider>
  )
}

export default (createFragmentContainer(Search, {
  viewer: graphql`
    fragment Search_viewer on Person {
      ...FullSearch_viewer
    }
  `,
}): RelayFragmentContainer<typeof(Search)>)
